import {
  LdsDefault,
  StyledKalturaLoader,
  StyledKalturaLoaderDot,
} from '../Kaltura/Kaltura.styles'
import cx from 'classnames'
import { useMemo } from 'react'

export const Loader = ({ showLoader }: { showLoader: boolean }) => {
  const dots = useMemo(
    () =>
      Array.from(Array(12).keys()).map(i => (
        <StyledKalturaLoaderDot key={i} theme={{ pos: i + 1 }} />
      )),
    []
  )

  return (
    <StyledKalturaLoader
      className={cx(['loaderWrpKaltura', showLoader ? 'show' : 'hide'])}
    >
      <LdsDefault>{dots}</LdsDefault>
    </StyledKalturaLoader>
  )
}
